import Vue, { Component, CreateElement, RenderContext, VNode } from "vue";
import { FormField } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseFormSubtitle from "@/components/BaseFormSubtitle";
import BaseInput from "@/components/BaseInput";
import BaseInputDate from "@/components/BaseInputDate";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseInputTime from "@/components/BaseInputTime";
import BaseSelect from "@/components/BaseSelect";
import BaseSwitch from "@/components/BaseSwitch";
import InputDateTime from "@/components/InputDateTime";
import InputMoney from "@/components/InputMoney";
import InputPassword from "@/components/InputPassword";
import InputPhone from "@/components/InputPhone";
import RichTextarea from "@/components/RichTextarea";

interface Props {
  field: FormField;
  value: any;
}
export default Vue.extend({
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    let component: Component = BaseInput;
    let { field, value, ...props } = ctx.props;
    if (ctx.scopedSlots.default) {
      const slotData = ctx.scopedSlots.default({
        field,
        listeners: ctx.listeners,
        value,
      });

      if (slotData && slotData.length === 1) {
        return slotData[0];
      } else if (slotData) return h("span", slotData);
    }
    let { type, style, class: clazz, ...fieldProps } = field;
    props = {
      ...props,
      ...fieldProps,
    };

    if (type === "password") component = InputPassword;
    else if (type === "date") component = BaseInputDate;
    else if (type === "time") component = BaseInputTime;
    else if (type === "textarea") component = BaseInputTextarea;
    else if (type === "rich-textarea") component = RichTextarea;
    else if (type === "select") component = BaseSelect;
    else if (type === "switch") component = BaseSwitch;
    else if (type === "phone") component = InputPhone;
    else if (type === "money") component = InputMoney;
    else if (type === "dateTime") component = InputDateTime;
    else if (type === "subtitle") component = BaseFormSubtitle;
    else if (type === "checkbox") component = BaseCheckbox;

    return h(component, {
      on: ctx.listeners,
      props: { ...props, value, type },
      class: [clazz, ctx.data.class, ctx.data.staticClass],
      style: [style, ctx.data.style, ctx.data.staticStyle],
    });
  },
});
